import 'angular-route';
import 'angular-cookies';
import angular from 'angular';
import router from './module.socialmedia.routes';
import commonServicesModule from '../../services';

export const socialmediaModule = {
	name: 'socialmedia',
	controllers: {
		default: 'socialMediaCtrl',
	},
	routes: {
		list: '/socialmedia',
	},
};

export default angular
	.module(socialmediaModule.name, ['ngRoute', 'ngCookies', commonServicesModule])
	.config(router)
	.controller(socialmediaModule.controllers.default, require('./socialMediaCtrl')).name;
